import { getApiWrapper, postApiWrapper ,postRequest} from "./wrapper";

export const postEvent = async (data)=>{
    const url = `https://demomeghwal.merasamaj.app/api/social_events`;
        const res = await postRequest(url, data);
    return res;
}